<template>
  <v-dialog v-model="modal" max-width="700">
    <v-card>
      <v-card-title>Supprimer la recherche</v-card-title>
      <v-card-text>
        Veuillez confirmer la suppression de cette recherche.
      </v-card-text>
      <v-card-actions>
        <v-btn text color="primary" :loading="enCours" @click="supprimer"
          >Supprimer</v-btn
        >
        <v-btn text @click="annuler">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      enCours: false,
      id: null,
    };
  },
  methods: {
    afficher(id) {
      this.modal = true;
      this.id = id;
    },
    supprimer() {
      this.enCours = true;
      this.$api('/recherche/avancee/mes/' + this.id)
        .delete()
        .then(() => {
          this.$emit('delete');
        })
        .finally(() => {
          this.modal = false;
          this.enCours = false;
        });
    },
    annuler() {
      this.modal = false;
    },
  },
};
</script>
